/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { StyledLoadingMessage } from "src/components/Block/styles";
import { Mono } from "src/components/Layout/Typography";

interface Props {
  msg?: string;
  children?: React.ReactNode;
}

export function MessageBlock({ msg, children }: Props) {
  return (
    <StyledLoadingMessage>
      {msg && <Mono>{msg}</Mono>}
      {children}
    </StyledLoadingMessage>
  );
}
